module.exports = __webpack_public_path__ + "img/settings_mic_icon.61d6cef3.svg";